<template>
  <div>
    <app-title>Partner Details</app-title>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex>Start Date:
          <date-picker
            v-model="startDate"
            lang="en-au"
            name="startDate"
            format="DD/MM/YYYY"
            placeholder="dd/MM/YYYY"
          ></date-picker>
        </v-flex>

        <v-flex>End Date:
          <date-picker
            v-model="endDate"
            lang="en-au"
            name="endDate"
            format="DD/MM/YYYY"
            placeholder="dd/MM/YYYY"
          ></date-picker>
        </v-flex>

        <v-flex>
          <v-btn color="success" @click="refresh(`details`)">Refresh Details</v-btn>
        </v-flex>
      </v-layout>

      <v-layout row wrap v-if="headers">
        <v-flex xs12>
          <list-details :items="details" title="Partner Details" :headers="headers"></list-details>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import globalMixin from "@/mixins/globalMixin";
import listDetails from "@/components/channelPartners/list-details";
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapPartnerActions } = createNamespacedHelpers("partner");

export default {
  name: "PartnerDetails",
  components: { listDetails },
  mixins: [globalMixin],
  data() {
    return {
      menu1: false,
      menu2: false,
      startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1)
        .toISOString()
        .substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      details: []
    };
  },
  computed: {
    headers() {
      if (this.details.length > 0) return this.getHeaders(this.details[0]);
      else return null;
    }
  },
  methods: {
    ...mapPartnerActions(["getPartnerData"]),
    refresh(option) {
      let vm = this;
      vm.label = option;
      let url = null;
      switch (option.toString().toLowerCase()) {
        case "details":
          url = `dealerPortal/ListChannelPartnerDetails`;
          break;

        default:
          break;
      }
      vm.getPartnerData({
        startDate: vm.startDate,
        endDate: vm.endDate,
        url: url
      })
        .then(data => {
          vm.details = data;
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
</style>